import { all } from 'redux-saga/effects';
import importApiSaga from './ApiSaga';
import importAuthSagas from './AuthSaga';
// API通信系のsagaの取得
export const getApiSagas = (options) => function* apiSagas() {
    yield all([importApiSaga(options)()]);
};
// 認証系のsagaの取得
export const getAuthSagas = () => function* authSagas() {
    yield all([importAuthSagas()()]);
};
